import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-942fb462"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pr-4" }
const _hoisted_2 = { class: "max-w-2xl pl-4" }
const _hoisted_3 = { class: "text-3xl mb-2 font-bold tracking-tight text-gray-900" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-graduation-cap" }, null, -1))
const _hoisted_5 = { class: "ml-2 font-semibold" }
const _hoisted_6 = { class: "mb-4 text-base leading-6 text-gray-600" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  role: "list",
  class: "mt-2 flex flex-col"
}
const _hoisted_9 = { class: "pl-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-1 bg-gray-200" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "p-inputgroup w-full md:w-30rem"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock mr-1" }),
  /*#__PURE__*/_createTextVNode(" wait ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "hours", -1))
const _hoisted_14 = { class: "flex relative" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa-solid fa-grip-vertical text-2xl text-gray-400 h-full my-auto mr-2 cursor-move handle hover:text-gray-600 transition-colors" }, null, -1))
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "ml-4 w-96" }
const _hoisted_18 = { class: "flex items-center mb-1" }
const _hoisted_19 = { class: "text-4xl mb-0 font-bold tracking-tight text-gray-900" }
const _hoisted_20 = { class: "mb-0 text-lg font-semibold leading-8 tracking-tight text-gray-900" }
const _hoisted_21 = { class: "text-base leading-7 text-gray-600" }
const _hoisted_22 = { class: "text-base leading-7 text-gray-400" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa-regular fa-clock mr-1" }, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "fa-solid fa-circle-check ml-3 mr-1"
}
const _hoisted_25 = {
  key: 1,
  class: "fa-regular fa-circle-check ml-3 mr-1"
}
const _hoisted_26 = { class: "ml-4" }
const _hoisted_27 = {
  key: 0,
  class: "h-14 ml-12 flex"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-1 bg-gray-200" }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "flex relative ml-4" }
const _hoisted_31 = { class: "aspect-[3/2] w-full rounded-2xl object-cover max-w-xs border-dashed border-4 border-gray-200 hover:border-gray-400 transition flex justify-center items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_AddCourseLessonDialog = _resolveComponent("AddCourseLessonDialog")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ConfirmDialog),
    _createVNode(_component_AddCourseLessonDialog, {
      visible: $data.dialogvisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (($data.dialogvisible) = $event)),
      onOnAddLesson: $options.addLessonToCourse
    }, null, 8, ["visible", "onOnAddLesson"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" Lessons: "),
          _createElementVNode("span", _hoisted_5, _toDisplayString($data.lessons.length), 1)
        ]),
        _createElementVNode("p", _hoisted_6, [
          _createTextVNode(" We’re a dynamic group of individuals who are passionate about what we do and dedicated to delivering the best results for our clients. "),
          _hoisted_7,
          _createTextVNode(" Estimated time to complete all lessons: "),
          _createElementVNode("b", null, _toDisplayString($options.lessonsEstimatedTime), 1),
          _createTextVNode(" minutes ")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("ul", _hoisted_8, [
          _createVNode(_component_draggable, _mergeProps({
            modelValue: $data.lessons,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.lessons) = $event)),
            "item-key": "lessonId",
            handle: ".handle"
          }, $options.dragOptions, { onUpdate: $options.onRearrangedLessons }), {
            item: _withCtx(({ element, index }) => [
              _createElementVNode("li", _hoisted_9, [
                (index > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["h-14 ml-12 flex transition-all ease-in-out duration-300", { '!h-36': element.hasCooldown }])
                    }, [
                      _hoisted_10,
                      _createElementVNode("div", {
                        class: _normalizeClass(["h-14 flex items-center gap-2 pl-1 transition-all ease-in-out duration-300", { '!h-36': element.hasCooldown }])
                      }, [
                        _createElementVNode("div", null, [
                          (element.hasCooldown)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                icon: "fa fa-lock text-2xl",
                                rounded: "",
                                text: "",
                                severity: "primary",
                                onClick: ($event: any) => (element.hasCooldown = false)
                              }, null, 8, ["onClick"]))
                            : (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                icon: "fa fa-unlock text-2xl",
                                rounded: "",
                                text: "",
                                severity: "secondary",
                                onClick: ($event: any) => (element.hasCooldown = true)
                              }, null, 8, ["onClick"]))
                        ]),
                        _createVNode(_Transition, { name: "fade" }, {
                          default: _withCtx(() => [
                            (element.hasCooldown)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _hoisted_12,
                                  _createVNode(_component_InputNumber, {
                                    modelValue: element.cooldown,
                                    "onUpdate:modelValue": ($event: any) => ((element.cooldown) = $event),
                                    placeholder: "Cooldown",
                                    style: {"width":"98px"}
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _hoisted_13
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ], 2)
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("img", {
                    class: "aspect-[3/2] w-full rounded-2xl object-cover max-w-xs shadow",
                    src: element.imageUrl,
                    alt: ""
                  }, null, 8, _hoisted_16),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("h2", _hoisted_19, _toDisplayString(index + 1) + ". ", 1),
                      _createVNode(_component_Button, {
                        class: "ml-2",
                        icon: "fa-solid fa-up-right-from-square",
                        severity: "secondary",
                        text: "",
                        rounded: "",
                        onClick: ($event: any) => ($options.onClickEditLesson(element))
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_Button, {
                        icon: "pi pi-trash",
                        severity: "secondary",
                        text: "",
                        rounded: "",
                        onClick: ($event: any) => ($options.removeLessonFromCourse(element))
                      }, null, 8, ["onClick"])
                    ]),
                    _createElementVNode("h3", _hoisted_20, _toDisplayString(element.title), 1),
                    _createElementVNode("p", _hoisted_21, _toDisplayString(element.description), 1),
                    _createElementVNode("p", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("span", null, _toDisplayString(element.estimatedTime) + " minutes ", 1),
                      (element.isPassFail)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                        : (_openBlock(), _createElementBlock("span", _hoisted_25)),
                      _createElementVNode("span", null, _toDisplayString(element.isPassFail ? "Pass/fail" : "Not pass/fail"), 1)
                    ])
                  ])
                ])
              ])
            ]),
            footer: _withCtx(() => [
              _createElementVNode("li", _hoisted_26, [
                ($data.lessons.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_Button, {
                      icon: "fa fa-plus",
                      rounded: "",
                      severity: "secondary",
                      "aria-label": "Filter",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.dialogvisible = true))
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          }, 16, ["modelValue", "onUpdate"])
        ])
      ])
    ])
  ]))
}